import { captureException } from '@core/product';
import type { HandleClientError } from '@sveltejs/kit';

export const handleError: HandleClientError = ({ error }) => {
  if (error instanceof Error) {
    captureException(error);
  }
};

// SvelteKit's generated `app.js` unconditionally imports `init` from this
// module. Without the export, Rollup warns (`"init" is not exported`) on
// every build even though runtime is fine with `undefined`. Export a
// no-op to silence the warning — swap to real bootstrap logic when a
// legitimate client-init need appears (service workers, early PostHog
// warmup, asset preload, etc.).
export const init = () => {};
